export default __webpack_public_path__ + "static/media/notify-alert.74f6cb42.png";